/// <amd-module name="SuiteCommerce.PagePrinter.EmptyState.EmptyState.ItemNotFound.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.PagePrinter.EmptyState.EmptyState.ItemNotFound.View", ["require", "exports", "sc-pageprinter-item-not-found.tpl", "Backbone", "SuiteCommerce.PagePrinter.EmptyState.Configuration"], function (require, exports, itemNotFoundTemplate, Backbone_1, EmptyState_Configuration_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var EmptyStateItemNotFoundView = /** @class */ (function (_super) {
        __extends(EmptyStateItemNotFoundView, _super);
        function EmptyStateItemNotFoundView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = itemNotFoundTemplate;
            _this.title = 'Item not found';
            _this.metaDescription = 'Item not found';
            return _this;
        }
        EmptyStateItemNotFoundView.prototype.getContext = function () {
            return {
                message: this.model.message,
                buttonLabel: this.model.buttonLabel,
                buttonURL: EmptyState_Configuration_1.EmptyStateConfiguration.getContinueShoppingURL
            };
        };
        return EmptyStateItemNotFoundView;
    }(Backbone_1.View));
    exports.EmptyStateItemNotFoundView = EmptyStateItemNotFoundView;
});
